import {
  AREAS_LOADING,
  GET_AREAS_SUCCESS,
  GET_AREAS_FAILURE
} from "../actions/types/areas";

const initialState = {
  data: [],
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AREAS_LOADING: {
      return {
        ...state,
        loading: true
      };
    }

    case GET_AREAS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: [...action.payload.data]
      };
    }

    case GET_AREAS_FAILURE: {
      return {
        ...state,
        loading: false
      };
    }

    case "RESET_MAP_REDUCER": {
      return {
        ...state,
        ...initialState
      };
    }

    default: {
      return state;
    }
  }
};
